<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px' append-to-body>
    <el-form :model='form' label-width='140px' label-position='right' :rules='rules'
             ref='ruleForm' class='dialogForm mt20'>
      <el-row>
        <el-col :span='12'>
          <el-form-item label='是否开具销售清单：'>
            {{ rowForm.isDetailedList |isDetailedListFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='交付方式：'>
            {{ rowForm.pushType |pushTypeFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票种类：'>
            {{ rowForm.invoiceLine |invoiceLineFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票类型：'>
            {{ rowForm.invoiceBlueOrRed |invoiceBlueOrRedFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12' v-if='rowForm.invoiceBlueOrRed === 1'>
          <el-form-item label='开具红票理由：'>
            {{ rowForm.blueRedReason |blueRedReasonFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票标识：'>
            {{ rowForm.invoiceFlag |invoiceFlagFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='代开标志：'>
            {{ rowForm.proxyInvoiceFlag |proxyInvoiceFlagFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='税率原因说明：'>
            {{ rowForm.specialTaxRateReason |specialTaxRateReasonFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票备注：'>
            {{ rowForm.invoiceRemark |valFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='收款人：'>
            {{ rowForm.payee |valFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='复核：'>
            {{ rowForm.reviewer |valFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票人：'>
            {{ rowForm.drawer |valFormat }}
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label='审核意见：' prop='auditOpinion'>
            <el-input type='textarea' v-model='form.auditOpinion' size='mini'
                      placeholder='请输入审核意见' />
          </el-form-item>
        </el-col>
      </el-row>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>同意
        </el-button>
        <el-button size='medium' type='danger' @click='reject'>驳回</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import DivBorder from '@/components/divBorder';
  import { selectPeople, vehicleSettlementAudit } from '@/service/financial';

  export default {
    name: 'vehicleSettlementForm',
    components: {
      BatchImport,
      DivBorder,
    },
    data() {
      return {
        importLoading: false,
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        rowForm: {},
        form: {},
        rules: {
          payee: [
            {
              required: true,
              message: '请选择收款人',
              trigger: 'blur',
            },
          ],
          reviewer: [
            {
              required: true,
              message: '请选择复核',
              trigger: 'blur',
            },
          ],
          drawer: [
            {
              required: true,
              message: '请选择开票人',
              trigger: 'blur',
            },
          ],
          auditOpinion: [
            {
              required: true,
              message: '请输入审核意见',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        selectedData: {},
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
      isDetailedListFormat(str) {
        return str === 1 ? '是' : str === 0 ? '否' : '无';
      },
      invoiceBlueOrRedFormat(str) {
        return str === 1 ? '红字发票' : str === 0 ? '蓝字发票' : '无';
      },
      pushTypeFormat(str) {
        switch (str) {
          case -1 :
            return '不交付';
          case 0 :
            return '邮箱交付';
          case 1 :
            return '手机交付';
          case 2 :
            return '邮箱、手机交付';
        }
      },
      invoiceLineFormat(str) {
        switch (str) {
          case 0 :
            return '增值税专用发票';
          case 2 :
            return '增值税普通发票(纸票)';
          case 12 :
            return '机动车销售统一发票';
          case 41 :
            return '增值税普通发票(卷式)';
          case 42 :
            return '二手车销售统一发票';
          case 51 :
            return '增值税普通电子发票';
          case 52 :
            return '增值税专用电子发票';
        }
      },
      invoiceFlagFormat(str) {
        switch (str) {
          case 0 :
            return '普通发票';
          case 1 :
            return '成品油发票';
          case 2 :
            return '收购发票';
          case 3 :
            return '机动车发票';
        }
      },
      proxyInvoiceFlagFormat(str) {
        switch (str) {
          case 0 :
            return '非代开';
          case 1 :
            return '待开';
        }
      },
      settTypeFormat(str) {
        switch (str) {
          case 1 :
            return '合同价';
          case 2 :
            return '合同价';
        }
      },
      specialTaxRateReasonFormat(str) {
        switch (str) {
          case 0 :
            return '无理由';
          case 1 :
            return '政策出台前发生纳税义务';
          case 2 :
            return '前期已开具相应征收率发票，发生销售折让、中止或者退回等情形需要开具红字发票，或者开票有误需要重新开具';
          case 3 :
            return '因为实际经营业务需要，放弃享受免征增值税政策';
        }
      },
      blueRedReasonFormat(str) {
        switch (str) {
          case 1 :
            return '销货退回';
          case 2 :
            return '开票有误';
          case 3 :
            return '服务中止';
          case 4 :
            return '销售折让';
        }
      },
    },
    mounted() {
      this.getSelectedData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await selectPeople();
        if (status !== 0) return this.$message.warning(message);
        this.selectedData = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.rowForm = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      reject() {
        this.$confirm('请选择驳回阶段', '驳回', {
          confirmButtonText: '退回到审核对账单',
          cancelButtonText: '退回到提交审核',
          distinguishCancelAndClose: true,
        })
          .then(async () => {
            const {
              status,
              message,
            } = await vehicleSettlementAudit({
              id: this.rowForm.id,
              attitude: 2,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
            this.$emit('searchBtn');
          })
          .catch(async action => {
            if (action === 'close') return false;
            const {
              status,
              message,
            } = await vehicleSettlementAudit({
              id: this.rowForm.id,
              attitude: 3,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
            this.$emit('searchBtn');
          });
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await vehicleSettlementAudit({
              id: this.rowForm.id,
              ...this.form,
              attitude: 1,
            });
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
            this.$emit('searchBtn');
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .dialogForm {
    width: 90%;
    margin: 0 auto;
  }

  ::v-deep {
    .el-form-item__content .el-input-group {
      vertical-align: revert;
    }
  }
</style>
